<template>
  <v-container fill-height style="min-width: 100%;" justify-content-center class="pa-0 login-background" :gradient="gradient" dark>
    <v-layout column align-center>
      <v-flex xs12 sm8 md5 lg4 xl3 offset-sm4 class="login-panel margin-auto pa-3" :class="{ 'fixed-width': $vuetify.breakpoint.smAndUp }">
        <div style="display: flex; justify-content: center;" id="logo" class="mb-2">
          <logo alwaysExtended :theme="theme" class="login-logo py-3" :height="50" />
        </div>
        <v-form ref="form" autocomplete="off">
          <v-text-field type="email"
            :dark="theme === 'dark'"
            autocomplete="nope"
            :readonly="state.loading"
            :rules="[rules.required]"
            :error="loginError"
            v-model="credentials.email"
            :color="theme === 'dark' ? 'white' : null"
            prepend-inner-icon="email"
            :placeholder="!credentials.email ? $t('fields.email') : ''"
            single-line
            autofocus
            filled />
          <v-text-field :dark="theme === 'dark'"
            autocomplete="nope"
            :readonly="state.loading"
            v-on:keyup.enter.prevent="signIn()"
            :rules="show ? [rules.required] : []"
            :error="loginError"
            v-model="credentials.password"
            :color="theme === 'dark' ? 'white' : null"
            type="password"
            prepend-inner-icon="vpn_key"
            :placeholder="$t('fields.password')"
            single-line
            filled
            autofocus
            :style="show ? '' : 'display: none;'" />
        </v-form>
        <!-- BUTTONS -->
        <v-btn v-if="!show" id="login-btn" :loading="loginError === false" block :color="theme === 'dark' ? 'white' : null" outlined @click="show = true" class="mb-3">{{$t('login.log_in_with_password')}}</v-btn>
        <v-btn v-else id="login-btn" :loading="loginError === false" block :color="theme === 'dark' ? 'white' : null" outlined @click="signIn()" class="mb-3">{{$t('actions.sign_in')}}</v-btn>
        <v-btn block :loading="loadingLink" :color="theme === 'dark' ? 'white' : null" outlined text @click="sendAccessLink()">{{$t('login.send_access_link')}}</v-btn>
        <!-- LINKS -->
        <div v-if="urlCookiesPolicy || urlPrivacyPolicy" class="pa-2 text-center caption mt-4" :class="theme === 'dark' ? 'white--text' : ''">
          <span v-if="urlCookiesPolicy" class="clickable underline" @click="openInNewTab({ route: urlCookiesPolicy, external: true })" v-text="$t('main.cookies_policy')" />
          <span v-if="urlPrivacyPolicy" class="clickable underline" @click="openInNewTab({ route: urlPrivacyPolicy, external: true })" v-text="$t('main.privacy_policy')" :class="{ 'ml-2': urlCookiesPolicy }" />
        </div>
        <div class="dark--text pa-2 text-center caption">
          v{{pjson.version}} Copyright © easygoband World S.L. {{moment().format('YYYY')}}
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import { URL_COOKIES_POLICY, URL_PRIVACY_POLICY } from '@/config/environment'
import { themeByColor } from '@/lib/helpers/ColorUtils'
import routingMixins from '@/mixins/Routing'
import pjson from '@/../package.json'
import moment from 'moment'

export default {
  data () {
    return {
      moment,
      pjson,
      title: process.env.VUE_APP_TITLE,
      valid: true,
      credentials: {
        email: null,
        password: null,
      },
      loginError: null,
      gradient: 'to top right, rgba(28,49,58, .8), rgba(69,90,100, .8)',
      rules: {
        required: value => !!value || '',
      },
      theme: themeByColor(this.$vuetify.theme.themes.light.accent.darken1),
      show: false,
      loadingLink: false,
      urlCookiesPolicy: URL_COOKIES_POLICY,
      urlPrivacyPolicy: URL_PRIVACY_POLICY,
    }
  },
  computed: {
    ...mapState(['state']),
  },
  components: {
    Logo: () => import('@/components/app-components/Logo.vue'),
  },
  methods: {
    signIn () {
      if (this.$refs.form.validate()) {
        this.loginError = false
        this.$store.dispatch('auth/signIn', { email: this.credentials.email, password: this.credentials.password }).catch(() => {
          this.loginError = true
        })
      }
    },
    sendAccessLink () {
      this.show = false
      if (this.$refs.form.validate()) {
        this.loadingLink = true
        this.$store.dispatch('auth/sendAccessMail', { email: this.credentials.email }).then(() => {
          this.$store.commit('state/setMessage', { text: this.$t('login.access_mail_sent'), color: 'success' })
          this.loadingLink = false
        })
      }
    },
  },
  mixins: [routingMixins],
}
</script>

<style scoped lang="scss">
.v-card {
  margin: 10px;
}
.centered {
  width: auto;
}
.centered > div {
  margin: 0 auto;
}
.headline {
  width: 100%;
}
.login-title {
  font-family: "Montserrat", sans-serif;
  font-size: 3em;
}
.login-logo {
  height: 4.5em !important;
  max-width: 60%;
}
.login-panel {
  border-radius: 10px;
  padding: 15px;
  max-height: fit-content;
}
.fixed-width {
  width: 350px;
  max-width: 350px !important;
}
</style>
